// More Like This (contract D.4.2, C.7): up to 5 neighbor shows, each with
// its date, venue and first reason. The whole row is the "Open show" button.
//
// Props: { band, neighbors, onOpenShow }
// Optional (additive): `fillBand` - neighbors matched from tape titles
// (source 'tracks') get a From tape badge; with no source, no badge.

import React from 'react';
import { IconOpen } from '../icons';
import { resolveBand, fmtDate, dateKeyFor } from './vibeUtil';
import { partBadges } from '../showPart';
import { FromTapeBadge, isFromTape } from '../fromTape';
import './vibe.css';

export default function MoreLikeThis({ band, neighbors, onOpenShow, fillBand }) {
  const b = resolveBand(band);
  const rows = (Array.isArray(neighbors) ? neighbors : []).filter((n) => n && n.sid && n.iso).slice(0, 5);
  if (!b || !rows.length) return null;
  const parts = partBadges(rows);

  return (
    <div className="vb-mlt">
      <div className="vb-label">More like this</div>
      {rows.map((n, i) => {
        const reason = Array.isArray(n.reasons) && n.reasons.length ? n.reasons[0] : null;
        const tape = !!fillBand && isFromTape(n);
        const where = [n.venue, n.location].filter(Boolean).join(', ') || (tape ? 'Venue unknown' : '');
        return (
          <button
            key={n.sid}
            type="button"
            className="row"
            title="Open show"
            aria-label={
              'Open show: ' + fmtDate(n.iso) + (parts[i] ? ' ' + parts[i].title.toLowerCase() : '') + (tape ? ', from tape' : '') + (where ? ', ' + where : '') + (reason ? '. ' + reason : '')
            }
            onClick={() =>
              onOpenShow({
                bandKey: b.key,
                iso: n.iso,
                dateKey: n.dateKey || dateKeyFor(b.key, n.iso),
                sid: n.sid,
                tapeId: null,
              })
            }
          >
            <div className="row-main">
              <div className="row-title">
                {fmtDate(n.iso)}
                {parts[i] && (
                  <span className="badge vb-part" title={parts[i].title}>
                    {parts[i].text}
                  </span>
                )}
                {tape && <FromTapeBadge row={n} className="vb-part vb-fromtape" />}
              </div>
              {where && <div className="row-sub">{where}</div>}
              {reason && <div className="row-sub dim clamp">{reason}</div>}
            </div>
            <IconOpen size={16} />
          </button>
        );
      })}
    </div>
  );
}
